import { Link, useAlert } from "capitalrx-components-2.0/lib/general";
import { useRequestDiscountCardMutation } from "@/api/getAdvantageCard";
import { CloseModalProp } from "@/api/interfaces/AdvantageCardRequest";
import { useGroupNumber } from "@/utils/useGroupNumber";
import { WhiteLabelSubmit } from "@/components/WhiteLabelComponents";
import { Paragraph } from "capitalrx-components-2.0/lib/typography";
import { Form, InputAlignmentContainer, TelephoneTextbox } from "capitalrx-components-2.0/lib/forms";

import styles from "../styles.module.scss";

const TextModal = (props: CloseModalProp): JSX.Element => {
  const { onClose } = props;

  const showAlert = useAlert();

  const [requestCard] = useRequestDiscountCardMutation();
  const group_number = useGroupNumber();

  const handleSubmit = async (payload: { phone_number: string }): Promise<void> => {
    await requestCard({
      request_type: 2,
      recipient: payload["phone_number"],
      group_number: group_number,
    })
      .unwrap()
      .then((data) =>
        showAlert({ message: "Text sent. You should receive a link for your discount card shortly.", type: "success", style: "toast" }),
      )
      .catch((data) => showAlert({ message: "Phone number was not submitted. Please try again.", type: "error", style: "toast" }));

    onClose();
  };

  return (
    <Form testId="advantage-modal-text" className={styles.ModalForm} onSubmit={handleSubmit}>
      <Paragraph className={styles.ModalFormTitle} textAlign="center">Text Discount Card</Paragraph>
      <Paragraph className={styles.ModalFormSubTitle} textAlign="center">Enter your phone number below to send this discount card to your phone.</Paragraph>
      <InputAlignmentContainer>
        <TelephoneTextbox.Field countryCode="US" name="phone_number" required />
        <WhiteLabelSubmit classNames={styles.ModalFormSubmit} text="Send Text" />
      </InputAlignmentContainer>
      <Paragraph className={styles.ModalFormDisclaimer}>
        By entering your phone number and selecting SEND, you agree that Msg &amp; data rates may apply. Terms and privacy information are
        available{" "}
        <Link to="https://cap-rx.com/legal" tooltip="Terms and privacy information">
          here
        </Link>
        .
      </Paragraph>
    </Form>
  );
};

export default TextModal;
